import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';

import App from 'Scenes/_root';
import './configured-sentry';
import './configured-amplify';
import './index.scss';

let rootEl = document.getElementById('root');

if (!rootEl) {
  const rootDiv = document.createElement('div');
  rootDiv.id = 'root';
  if (document.body) {
    document.body.appendChild(rootDiv);
  }
  rootEl = rootDiv;
}

ReactDOM.render(
  <App />,
  rootEl
);
